import React from 'react';
import { SummaryTableSC } from './summary-table.styled';
import { BodyText, SmallText } from '../../../typography';
import { FormattedMessage } from 'react-intl';
import numeral from 'numeral';
import dlt from '../../../../utils/default-lang';
import Moment from 'react-moment';

const SummaryTable = ({ offerDetail, isBiddingTable }) => {
  return (
    <SummaryTableSC>
      <div className="loan-summary-wrap">
        <div className="loan-summary-wrap--bottom">
          <div className="loan-summary-wrap--bottom__row">
            <SmallText className="black-transparent">
              <FormattedMessage
                id="investor_secondary_market_buy_modal_sell_amount"
                defaultMessage={dlt['investor_secondary_market_buy_modal_sell_amount']}
              />
            </SmallText>
            <BodyText className="bolder">
              {numeral(
                Number(
                  isBiddingTable ? offerDetail.amount_for_sale : offerDetail.offered_value || 0
                )
              ).format('0,00.00')}{' '}
              €
            </BodyText>
          </div>
          <div className="loan-summary-wrap--bottom__row">
            <SmallText className="black-transparent">
              <FormattedMessage
                id="investor_secondary_market_table_future_value"
                defaultMessage={dlt['investor_secondary_market_table_future_value']}
              />
            </SmallText>
            <BodyText className="bolder">
              {offerDetail.futureValue
                ? numeral(Number(offerDetail.futureValue || 0)).format('0,00.00')
                : '-'}{' '}
              €
            </BodyText>
          </div>
          <div className="loan-summary-wrap--bottom__row">
            <SmallText className="black-transparent">
              <FormattedMessage
                id="investor_secondary_market_buy_modal_revenue"
                defaultMessage={dlt['investor_secondary_market_buy_modal_revenue']}
              />
            </SmallText>
            <BodyText className="bolder">
              {numeral(Number(offerDetail.interestRate) * 100).format('0.[00]')}%
            </BodyText>
          </div>
          <div className="loan-summary-wrap--bottom__row">
            <SmallText className="black-transparent">
              <FormattedMessage
                id="investor_secondary_market_buy_modal_name"
                defaultMessage={dlt['investor_secondary_market_buy_modal_name']}
              />
            </SmallText>
            <BodyText className="bolder">{offerDetail.debtor.wmNumber}</BodyText>
          </div>
          <div className="loan-summary-wrap--bottom__row">
            <SmallText className="black-transparent">
              <FormattedMessage
                id="investor_secondary_market_buy_modal_payments"
                defaultMessage={dlt['investor_secondary_market_buy_modal_payments']}
              />
            </SmallText>
            <BodyText className="bolder">
              {offerDetail.paidInstallmentCount} / {offerDetail.installmentCount}
            </BodyText>
          </div>
          <div className="loan-summary-wrap--bottom__row">
            <SmallText className="black-transparent">
              <FormattedMessage
                id="investor_secondary_market_buy_modal_date"
                defaultMessage={dlt['investor_secondary_market_buy_modal_date']}
              />
            </SmallText>
            <BodyText className="bolder" as="span">
              <Moment parse="YYYY-MM-DD" format="DD. MMMM YYYY" element="span">
                {offerDetail.loanSignedAt}
              </Moment>
            </BodyText>
          </div>
          <div className="loan-summary-wrap--bottom__row">
            <SmallText className="black-transparent">
              <FormattedMessage
                id="investor_secondary_market_buy_modal_status"
                defaultMessage={dlt['investor_secondary_market_buy_modal_status']}
              />
            </SmallText>
            <BodyText className="bolder">
              {offerDetail.isInArrears ? (
                <FormattedMessage id="global_late" defaultMessage={dlt['global_late']} />
              ) : (
                <FormattedMessage id="global_paying" defaultMessage={dlt['global_paying']} />
              )}
            </BodyText>
          </div>
        </div>
      </div>
    </SummaryTableSC>
  );
};

export default SummaryTable;
